import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";
import { SmoothScroll, RouteScroll } from "@/components/site/SmoothScroll";
import HomePage from "@/pages/HomePage";
import InstallationPage from "@/pages/InstallationPage";
import ServicesPage from "@/pages/ServicesPage";
import BatteriesPage from "@/pages/BatteriesPage";
import AboutPage from "@/pages/AboutPage";
import AreasPage from "@/pages/AreasPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";

const NotFound = () => (
  <main className="grid min-h-[70vh] place-items-center bg-[#08090a] px-5 pt-[72px] text-center" data-testid="not-found-page">
    <div>
      <p className="eyebrow">404</p>
      <h1 className="mt-4 text-4xl font-semibold uppercase text-white">Page not found</h1>
      <Link to="/" className="btn btn-primary mt-8">Back to Home</Link>
    </div>
  </main>
);

function App() {
  return (
    <div className="App bg-[#08090a]">
      <BrowserRouter>
        <SmoothScroll />
        <RouteScroll />
        <Nav />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/solar-installation" element={<InstallationPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/solar-batteries" element={<BatteriesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/service-areas" element={<AreasPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms-of-service" element={<LegalPage kind="terms" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <MobileBar />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
